// extracted by mini-css-extract-plugin
module.exports = {"afb__preview-link":"AmazonPreviewLink_afb__preview-link__c1Ntj","center":"AmazonPreviewLink_center__Xd6XP","bookCard":"AmazonPreviewLink_bookCard__fuKRe"};